<h2 mat-dialog-title class="text-center">{{ inputData.title }}</h2>
<mat-dialog-content>
  <app-list-component [data]="inputData.data" [multi]="inputData.multi!" (Values)="getIdItemList($event)" ></app-list-component>
</mat-dialog-content>
<mat-dialog-actions align="end" class="d-flex justify-content-end">
  <button matButton (click)="close()" class="bg-mat-red">{{inputData.action??'Fermer'}}</button>
</mat-dialog-actions>
